module.exports = __webpack_public_path__ + "static/img/enterprise4.f09c16d2.png";